import { action, computed, observable, runInAction } from 'mobx';
import {
    Comentario,
    Months,
    RegistroEnviardo,
    RegistroEnviardoResponse,
    RegistroImpuestosEstado
} from '../models';
import { Reintegro } from '../models/Responses';
import { registroImpuestosAguaStore } from './registroImpuestosAguaStore';
import { registroImpuestosPredialStore } from './registroImpuestosPredialStore';
import { requestStore } from './requestStore';

import { consultaStore } from '.';
import { EstadosRegistro, FiltrosConsultas } from '../models/Consultas';

export class AprobacionStore {
    @observable
    forms: RegistroEnviardo[] = [];

    @observable
    selectedForm: RegistroEnviardo | null = null;

    @observable
    cargando: boolean = false;

    @observable
    ingres: string = '';

    @observable
    reintegro: Reintegro | null = null;

    @observable
    filtros: FiltrosConsultas = {
        Municipio: 0,
        Ejercicio: 0,
        Mes: 0,
        Tipo: 0,
        Estado: 0,
        Captura: '0',
        Bandera: true
    };

    @computed
    get hasComments() {
        return this.impuestoStore.newComment.length > 0;
    }

    @computed
    get isAgua() {
        return this.selectedForm && this.selectedForm.tipoImpuesto === 'Agua';
    }

    @computed
    get impuestoStore() {
        return this.isAgua ? registroImpuestosAguaStore : registroImpuestosPredialStore;
    }

    @computed
    get registroImpuestos() {
        return this.isAgua
            ? this.impuestoStore.registroImpuestos
            : this.impuestoStore.registroImpuestos;
    }

    @computed
    get isSelected(): boolean {
        return this.selectedForm !== null;
    }

    @computed
    get monthString() {
        let mes = 'enero';
        if (this.isSelected) {
            mes = Months[this.selectedForm!.mes - 1];
        }
        return mes;
    }

    @action
    updateComment(comment: string) {
        this.impuestoStore.newComment = comment;
    }

    @action
    resetNewComment() {
        this.impuestoStore.newComment = '';
    }

    @action
    selectForm(form: RegistroEnviardo) {
        this.selectedForm = {
            id: form.id,
            ejercicio: form.ejercicio,
            mes: form.mes,
            municipioId: form.municipioId,
            municipioNombre: form.municipioNombre,
            estado: form.estado,
            tipoImpuesto: form.tipoImpuesto,
            consultaId: form.consultaId,
            modificacionFecha: '',
            mesString: ''
        };
    }

    @action
    unselect() {
        this.selectedForm = null;
        this.impuestoStore.newComment = '';
    }

    @action
    async getEnviarForms() {
        this.cargando=true;
        const forms = await requestStore.getEnviarForms(this.filtros.Estado, this.filtros.Municipio);
        if (forms) {
            forms.forEach(registro => {
                const fechaModificacion = new Date(registro.modificacionFecha);
                registro.modificacionFecha = fechaModificacion.toLocaleDateString()+' '+fechaModificacion.toLocaleTimeString();
                registro.mesString = consultaStore.mesString(registro.mes);
            });
            this.forms = forms as RegistroEnviardoResponse;
        }
        this.cargando=false;
    }

    @action
    async getIngres() {
        const response = await requestStore.getIngres();
        if (response) {
            this.ingres = response;
        }
    }

    @action
    async getReintegro() {
        const response = await requestStore.getReintegro();
        if (response) {
            this.reintegro = response;
        }
    }

    @action
    aprobar = async () => {
        const response = await requestStore!.aprobarFormatos(
            this.registroImpuestos.id,
            this.isAgua ? 'agua' : 'predial',
            this.impuestoStore.newComment
        );

        const success = response !== null && response !== 'failure';
        if (success) {
            this.registroImpuestos.estado = RegistroImpuestosEstado.Aprobado;
            this.registroImpuestos.comentarios = (response as Comentario).comentario;
            this.resetNewComment();
            this.selectedForm!.isActed = true;
        }
    };

    @action
    rechazar = async () => {
        const formResponse = await requestStore!.rechazarFormatos(
            this.registroImpuestos.id,
            this.isAgua ? 'agua' : 'predial',
            this.impuestoStore.newComment
        );

        const success = formResponse !== null && formResponse !== 'failure';
        if (success) {
            this.registroImpuestos.estado = RegistroImpuestosEstado.Rechazado;
            this.registroImpuestos.comentarios = (formResponse as Comentario).comentario;
            this.resetNewComment();
            this.selectedForm!.isActed = true;
        }
    };

    @action
    async getFormById() {
        this.impuestoStore.isLoading = true;
        this.cargando = true;

        const type = this.isAgua ? 'agua' : 'predial';
        const formResponse = await requestStore!.getFromById(this.selectedForm!.id, type);

        runInAction(() => {
            Object.assign(this.registroImpuestos, formResponse);
            this.impuestoStore.apertura.ejercicio = formResponse!.ejercicio!;
            this.impuestoStore.isLoading = false;
            this.cargando = false;
        });
    }
}

export const aprobacionStore = new AprobacionStore();
